import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Home from "@/pages/Home";
import About from "@/pages/About";
import Experience from "@/pages/Experience";
import Tips from "@/pages/Tips";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import Social from "@/pages/Social";
import Contact from "@/pages/Contact";
import Mentions from "@/pages/Mentions";
import Privacy from "@/pages/Privacy";
import Impressum from "@/pages/Impressum";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

// Context
import { LanguageProvider } from "@/context/LanguageContext";

// Analytics
import GoogleAnalytics from "@/components/GoogleAnalytics";

function App() {
  return (
    <LanguageProvider>
      <GoogleAnalytics />
      <div className="App min-h-screen bg-slate-50">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/tips" element={<Tips />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Article />} />
            <Route path="/social" element={<Social />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<Mentions />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
